import { errorNotice, type SaveBarNotice, successNotice } from '../../../components/SaveBarNotice/saveBarNotice'
import { type Account } from '../../../models/Account'
import { type TemplateValue } from '../../../models/TemplateLibrary'

const SAVE_NOTICE_MS = 8000

interface ApiError {
  status?: unknown
  data?: { errors?: Array<{ message?: unknown }> }
}

export const badRequestMessage = (error: unknown): string | undefined => {
  const { status, data } = (error ?? {}) as ApiError
  const message = data?.errors?.[0]?.message
  return status === 400 && typeof message === 'string' && message.trim() !== '' ? message : undefined
}

export const templateSaveNotices = {
  saved: (): SaveBarNotice => successNotice('Changes saved', { autoHideMs: SAVE_NOTICE_MS }),
  saveFailed: (error?: unknown): SaveBarNotice =>
    errorNotice(badRequestMessage(error) ?? 'Something went wrong saving this template.', { autoHideMs: SAVE_NOTICE_MS }),
}

export const OWNED_BY_ANOTHER_USER_TEXT = 'This is a template owned by a user.'

export const UNOPENABLE_TEMPLATE_TEXT = "This template can't be opened in the editor."

export const SCHEDULING_VIEW_ONLY_TEXT = 'Scheduling emails are managed at the account level. You can view them here.'

export const isOwnedByAnotherUser = (templateValue: TemplateValue, userId: string): boolean =>
  templateValue.scope === 'user' && 'createdBy' in templateValue && templateValue.createdBy !== userId

export const disabledBannerTextFor = (templateValue: TemplateValue, account: Account | undefined): string => {
  if (account?.enterpriseConfig.lockTemplates) {
    return 'Templates are managed at the enterprise level. You can’t edit or duplicate them.'
  }
  return templateValue.scope === 'system'
    ? 'This is a system template maintained by Zocks. You can’t edit it. Duplicate it to create your own version.'
    : 'This is an enterprise template. You can’t edit it. Duplicate it to create your own version.'
}
